"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FuturesBalancesPositionsTable = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom/cjs/react-router-dom");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Table = require("../../data/table/Table");
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
var _reactI18next = require("react-i18next");
var _numberFormatter = require("../../../helpers/numberFormatter");
var _dateHelper = require("../../../helpers/dateHelper");
var _path = _interopRequireDefault(require("../../../helpers/path"));
var _APButton = _interopRequireDefault(require("../../common/APButton"));
var _Tooltip = _interopRequireDefault(require("../../common/Tooltip/Tooltip"));
require("./BalancesTable.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var formatMoney = function formatMoney(value, product) {
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, (0, _numberFormatter.formatNumberToLocale)(value, product), /*#__PURE__*/_react["default"].createElement("span", {
    className: "-currency"
  }, " ", product));
};
var createCls = (0, _cssClassesHelper.getBEMClasses)('wallet-balances-table');
var renderCell = function renderCell(line1, line2) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var showApprox = options.approxSymbol !== false && !!line2;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: createCls('num-cell-futures-positions')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: createCls('num-cell__value')
  }, line1, options.percentage && /*#__PURE__*/_react["default"].createElement("span", {
    className: createCls('num-cell__percentage')
  }, "(", options.percentage, ")")), !!line2 && /*#__PURE__*/_react["default"].createElement("div", {
    className: createCls('num-cell__notional-futures-positions') + (showApprox ? ' ' + createCls('num-cell__notional-futures-positions--approx') : '')
  }, /*#__PURE__*/_react["default"].createElement("span", null, showApprox ? '≈ ' : '', line2)));
};
var FuturesBalancesPositionsTable = exports.FuturesBalancesPositionsTable = function FuturesBalancesPositionsTable(_ref) {
  var products = _ref.products,
    loading = _ref.loading,
    notionalProduct = _ref.notionalProduct,
    selectInstrument = _ref.selectInstrument;
  var _useTranslation = (0, _reactI18next.useTranslation)('futures'),
    t = _useTranslation.t;
  var columns = (0, _react.useMemo)(function () {
    return [{
      header: t('Actions'),
      id: 'Actions',
      size: 95,
      minSize: 95,
      maxSize: 95,
      meta: {
        textAlign: 'center',
        fixedWidth: true
      },
      className: 'actions',
      cell: function cell(_ref2) {
        var row = _ref2.row;
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: createCls('trade-button')
        }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
          to: (0, _path["default"])('/exchange/futures')
        }, /*#__PURE__*/_react["default"].createElement(_APButton["default"], {
          type: "button",
          onClick: function onClick() {
            return selectInstrument(row.original.InstrumentId);
          }
        }, /*#__PURE__*/_react["default"].createElement("span", null, t('Trade')))));
      }
    }, {
      header: t('Pair'),
      accessorKey: 'InstrumentSymbol',
      enableSorting: true,
      sortingFn: function sortingFn(rowA, rowB) {
        return rowA.original.InstrumentSymbol.localeCompare(rowB.original.InstrumentSymbol);
      },
      cell: function cell(_ref3) {
        var row = _ref3.row;
        return renderCell(row.original.InstrumentSymbol, "".concat(row.original.PositionType, " ").concat(row.original.Leverage, "x"), {
          approxSymbol: false
        });
      },
      meta: {
        textAlign: 'left'
      }
    }, {
      header: t('Size / Value'),
      accessorKey: 'PositionValue',
      enableSorting: true,
      sortingFn: function sortingFn(rowA, rowB) {
        return rowA.original.PositionValue - rowB.original.PositionValue;
      },
      cell: function cell(_ref4) {
        var row = _ref4.row;
        return renderCell(formatMoney(row.original.PositionSize, row.original.BaseProductSymbol || ''), formatMoney(row.original.PositionValue, row.original.QuoteProductSymbol || ''), {
          approxSymbol: false
        });
      },
      meta: {
        textAlign: 'right'
      }
    }, {
      header: t('Entry / Mark Price'),
      accessorKey: 'AverageEntryPrice',
      enableSorting: true,
      sortingFn: function sortingFn(rowA, rowB) {
        return rowA.original.EntryPrice - rowB.original.EntryPrice;
      },
      cell: function cell(_ref5) {
        var row = _ref5.row;
        return renderCell(formatMoney(row.original.EntryPrice, row.original.QuoteProductSymbol || ''), formatMoney(row.original.MarkPrice, row.original.QuoteProductSymbol || ''), {
          approxSymbol: false
        });
      },
      meta: {
        textAlign: 'right'
      }
    }, {
      header: t('Liquidation Price'),
      accessorKey: 'LiquidationPrice',
      enableSorting: true,
      cell: function cell(_ref6) {
        var row = _ref6.row;
        return renderCell(formatMoney(row.original.LiquidationPrice, row.original.QuoteProductSymbol || ''));
      },
      meta: {
        textAlign: 'right'
      }
    }, {
      header: /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
        text: t('Value reserved from your balance upon opening each position.')
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "wallet-balances-table__header-tooltip"
      }, t('Initial Margin'))),
      accessorKey: 'InitialMarginNotional',
      enableSorting: true,
      sortingFn: function sortingFn(rowA, rowB) {
        return rowA.original.InitialMarginNotional - rowB.original.InitialMarginNotional;
      },
      cell: function cell(_ref7) {
        var row = _ref7.row;
        return renderCell(formatMoney(row.original.InitialMargin, row.original.SettlementProductSymbol || ''), formatMoney(row.original.InitialMarginNotional, notionalProduct.Product), {
          isBaseAsset: true
        });
      },
      meta: {
        textAlign: 'right'
      }
    }, {
      header: /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
        text: t('Value required in your futures balance to maintain positions open and avoid liquidation.')
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "wallet-balances-table__header-tooltip"
      }, t('Maintenance Margin'))),
      accessorKey: 'MaintenanceMarginNotional',
      enableSorting: true,
      sortingFn: function sortingFn(rowA, rowB) {
        return rowA.original.MaintenanceMarginNotional - rowB.original.MaintenanceMarginNotional;
      },
      cell: function cell(_ref8) {
        var row = _ref8.row;
        return renderCell(formatMoney(row.original.MaintenanceMargin, row.original.SettlementProductSymbol || ''), formatMoney(row.original.MaintenanceMarginNotional, notionalProduct.Product), {
          isBaseAsset: true
        });
      },
      meta: {
        textAlign: 'right'
      }
    }, {
      header: /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
        text: t('Indicates the current, "paper" profit or loss of each open futures position.')
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "wallet-balances-table__header-tooltip"
      }, t('Unrealized P&L'))),
      accessorKey: 'UnrealizedProfitAndLossNotional',
      enableSorting: true,
      sortingFn: function sortingFn(rowA, rowB) {
        return rowA.original.UnrealizedProfitAndLossNotional - rowB.original.UnrealizedProfitAndLossNotional;
      },
      cell: function cell(_ref9) {
        var row = _ref9.row;
        return renderCell(formatMoney(row.original.UnrealizedProfitAndLoss, row.original.SettlementProductSymbol || ''), formatMoney(row.original.UnrealizedProfitAndLossNotional, notionalProduct.Product), {
          percentage: "".concat((0, _numberFormatter.formatNumberToLocale)(row.original.UnrealizedProfitAndLossPercentage, 2), "%")
        });
      },
      meta: {
        textAlign: 'right'
      }
    }, {
      header: /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
        text: t('Indicates the actual cumulative profit or loss derived from one or more closed portions in each position (if any).')
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "wallet-balances-table__header-tooltip"
      }, t('Realized P&L'))),
      accessorKey: 'RealizedProfitAndLossNotional',
      enableSorting: true,
      sortingFn: function sortingFn(rowA, rowB) {
        return rowA.original.RealizedProfitAndLossNotional - rowB.original.RealizedProfitAndLossNotional;
      },
      cell: function cell(_ref0) {
        var row = _ref0.row;
        return renderCell(formatMoney(row.original.RealizedProfitAndLoss, row.original.SettlementProductSymbol || ''), formatMoney(row.original.RealizedProfitAndLossNotional, notionalProduct.Product));
      },
      meta: {
        textAlign: 'right'
      }
    }, {
      header: t('Date Opened'),
      accessorKey: 'DateTimeOpened',
      enableSorting: true,
      cell: function cell(_ref1) {
        var row = _ref1.row;
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: createCls('num-cell-futures-positions')
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: createCls('num-cell__value')
        }, (0, _dateHelper.formatDate)(row.original.DateTimeOpened)), /*#__PURE__*/_react["default"].createElement("div", {
          className: createCls('num-cell__value')
        }, (0, _dateHelper.formatTime)(row.original.DateTimeOpened)));
      },
      meta: {
        textAlign: 'right'
      }
    }, {
      header: t('Position ID'),
      accessorKey: 'PositionId',
      enableSorting: true,
      cell: function cell(_ref10) {
        var row = _ref10.row;
        return renderCell(row.original.PositionId);
      },
      meta: {
        textAlign: 'right'
      }
    }];
  }, [t, selectInstrument, notionalProduct]);
  return /*#__PURE__*/_react["default"].createElement(_Table.Table, {
    data: products,
    columns: columns,
    loading: loading,
    stickyColumns: {
      left: ['Actions', 'Pair']
    },
    className: createCls(),
    emptyMessage: t('No Futures Positions Found'),
    rowClassName: function rowClassName() {
      return '';
    }
  });
};
FuturesBalancesPositionsTable.propTypes = {
  products: _propTypes["default"].array,
  loading: _propTypes["default"].bool,
  notionalProduct: _propTypes["default"].shape({
    DecimalPlaces: _propTypes["default"].number.isRequired,
    Product: _propTypes["default"].string.isRequired
  }),
  selectInstrument: _propTypes["default"].func
};